import { types } from '../actions/filtersOptionsFromApi';

const initialState = {
  filters: {
    Locations: [],
    Years: [],
    Status: [],
    Contractors: [],
    ClaimNames: []
  }
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case types.GET_OPTIONS_FILTERS_FULFILLED:
      return { ...state, filters: action.payload };
    default:
      return state;
  }
}
